import {
  ActionTypes,
  FetchOrdersByUserStartAction,
  FetchOrdersByUserSuccessAction,
  FetchOrdersByUserFailAction,
  ClearOrders,
  SaveSelectedOrder,
} from './types';

import { Order } from '@/types/order';

const fetchOrdersByUserStart = (): FetchOrdersByUserStartAction => ({
  type: ActionTypes.FETCH_ORDERS_BY_USER_START,
});

const fetchOrdersByUserSuccess = (payload: [], totalItems: number): FetchOrdersByUserSuccessAction => ({
  type: ActionTypes.FETCH_ORDERS_BY_USER_SUCCESS,
  payload,
  totalItems,
});

const fetchOrdersByUserFail = (payload: string): FetchOrdersByUserFailAction => ({
  type: ActionTypes.FETCH_ORDERS_BY_USER_FAIL,
  payload,
});

const clearOrders = (): ClearOrders => ({
  type: ActionTypes.CLEAR_ORDERS,
});

const saveSelectedOrder = (payload: Order | undefined): SaveSelectedOrder => ({
  type: ActionTypes.SAVE_SELECTED_ORDER,
  payload,
});

export { fetchOrdersByUserStart, fetchOrdersByUserSuccess, fetchOrdersByUserFail, clearOrders, saveSelectedOrder };
